'use client'

import "./style.css";
import React, { useCallback, useEffect, useState } from 'react'
import LaptopCalendarView from './LaptopCalendarView'
import MobileCalendarView from './MobileCalendarView/page'
import Helper from '../../util/helper';
import { useDispatch } from 'react-redux';
import { multicenterActions, formatMsg, calendarActions, packageActions, accountPackageActions, timeutil, permissions } from 'sharedresources';
import { getItem, removeItem } from "../../libs/encryptedStorage";
import styles from './style.module.css'
import { getParticipantsScheduleAttendanceByAccountId } from "../../redux/attendance/reducer";
import { Col, Input, Row, Tooltip } from "antd";
import { AttendanceStatus } from "../../types/attendance";
import { SearchOutlined } from "@ant-design/icons";
import { getAllBatches } from "../../redux/package/reducer";
const { getAllCentersList } = multicenterActions;
const { fetchPackage } = packageActions;
const { getPackageList } = accountPackageActions;
const { getScheduleDetail, sagaSuccess } = calendarActions;


const page = (props) => {


	const dispatch = useDispatch();

	const { firebase, calendarReducer, packageReducer, accountPackageReducer, multicenterReducer, attendanceReducer } = Helper.getSelectorState(["calendarReducer", "packageReducer", "accountPackageReducer", "multicenterReducer", "attendanceReducer"]);


	// Parent component common things 
	const [packageList, setPackageList] = useState([]);
	const [packageFilter, setpackageFilter] = useState(undefined);
	const [packageMap, setPackageMap] = useState(new Map());
	const [listWithColors, setListWithColors] = useState([]);
	const [filteredCalendars, setFilteredCalendars] = useState([]);
	const [instructorFilter, setInstructorFilter] = useState(undefined);
	const [teacherMap, setTeacherMap] = useState(new Map());
	const [packageColorMap, setPackageColorMap] = useState(new Map());
	const [toggle, setToggle] = useState(1);
	const [centerFilter, setCenterFilter] = useState(undefined);
	const [centerMap, setCenterMap] = useState(new Map());
	const [search, setSearch] = useState<any>();
	const [debouncedSearch, setDebouncedSearch] = useState("");
	const [selectedSchedule, setSelectedSchedule] = useState<any>(JSON.parse(getItem('selectedSchedule')) || null);
	const [batchFilter, setBatchFilter] = useState(undefined);
	const [filteredBatchList, setFilteredBatchList] = useState(undefined);
	const [batchesMap, setBatchesMap] = useState(new Map());

	const dateSlotCenterKey = selectedSchedule
		? `${timeutil.inFormat(selectedSchedule.date, 'DD-MM-YY')}--${selectedSchedule.slotRandomId}--${selectedSchedule.centerId}`
		: '';
	const [participantSearch, setParticipantSearch] = useState(undefined);
	const [filteredParticipantsList, setFilteredParticipantsList] = useState(undefined);
	const [participantAttendanceStats, setParticipantAttendanceStats] = useState(undefined);
	const {
		participantsAttendanceMap,
	} = attendanceReducer;
	useEffect(() => {
		if (selectedSchedule && Helper.isAccount(firebase)) {
			dispatch(getParticipantsScheduleAttendanceByAccountId({
				firebase,
				selectedSchedule: selectedSchedule,
				accountId: firebase.user.id
			}));
		}
	}, [selectedSchedule])

	useEffect(() => {

		let tempFilteredList = calendarReducer.scheduleDetail?.students || [];

		tempFilteredList = tempFilteredList.filter((participantObj) => {
			const nameMatch = Helper.filterSearchHelper(participantSearch, participantObj?.name);
			return nameMatch;
		});

		setFilteredParticipantsList(tempFilteredList);

	}, [calendarReducer.scheduleDetail?.students, participantSearch]);



	useEffect(() => {

		const participantAttendanceStats = { pending: 0, present: 0, absent: 0 };

		(calendarReducer.scheduleDetail?.students || []).forEach((participantObj) => {

			const dateSlotCenterEntityKey = dateSlotCenterKey + `--${participantObj.id}`;

			const displayAttendanceObj = participantsAttendanceMap.get(dateSlotCenterEntityKey);;
			const attendanceStatus: AttendanceStatus = Helper.getAttendanceStatus(displayAttendanceObj);

			if (attendanceStatus === 'PENDING' || attendanceStatus === 'CLEARED') participantAttendanceStats.pending++;
			else if (attendanceStatus === 'PRESENT') participantAttendanceStats.present++;
			else if (attendanceStatus === 'ABSENT') participantAttendanceStats.absent++;
		});

		setParticipantAttendanceStats(participantAttendanceStats);

	}, [calendarReducer.scheduleDetail?.students, participantsAttendanceMap]);

	function getParticipantsChildren() {
		return (
			<div>
				<div className={styles.participantsTopSection}>

					<Input
						className='fc-search fc-search-outlined'
						placeholder={Helper.getSelectedUserTypeName(firebase, formatMsg("searchParticipants"), formatMsg('search'), null, "LOWERCASE")}
						value={participantSearch}
						onChange={(e) => {
							e.preventDefault();
							setParticipantSearch(e.target.value);
						}}
						suffix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
						style={{ width: "250px" }}
					/>

				</div>
				<div className="attn-drawer-scrollable-container">
					<Row gutter={[0, 14]} >
						{
							filteredParticipantsList?.filter(s => s.status.toLowerCase() === "active").map((accountObj, key) => {
								const renderParticipantContent = () => (
									<div className={styles.userData}>
										<div className={styles.imgContainer}>
											<img
												className={styles.profileIcon}
												src={Helper.getProfileImageUrl(accountObj)}
											/>
											{
												getEntityAttendanceStatusIcon(
													accountObj.id
												)
											}
										</div>
										<div className={styles.dataContainer}>
											<div className={styles.userDesc}>
												<div className={styles.subheaderRegular}>
													{accountObj.name}
												</div>
											</div>
											<div className={styles.attendanceStatus}>
												{
													getEntityAttendanceStatus(
														accountObj.id
													)
												}
											</div>
											{getAbsentNote(accountObj.id)}
										</div>
									</div>
								)
								return (
									<>
										<div key={key} className={styles.teacherRowWrapper}>
											<Col span={17} key={key}>
												{renderParticipantContent()}
											</Col>

										</div>
									</>
								)
							})
						}
					</Row>
				</div>
			</div >
		)
	}

	function getAbsentNote(entityId: string) {

		const dateSlotCenterEntityKey = dateSlotCenterKey + `--${entityId}`;
		const displayAttendanceObj = participantsAttendanceMap.get(dateSlotCenterEntityKey);

		if (displayAttendanceObj?.absentNote) {
			const note = displayAttendanceObj.absentNote;
			const isTruncated = note.length > 20;
			const displayedNote = isTruncated ? `${note.slice(0, 20)}...` : note;
			return <div className={styles.absentNote}>
				{isTruncated ? (
					<Tooltip title={note}>
						<span>{displayedNote}</span>
					</Tooltip>
				) : (
					<span>{displayedNote}</span>
				)}
			</div>
		}

		return null;
	}

	function getEntityAttendanceStatus(entityId: string) {
		const dateSlotCenterEntityKey = dateSlotCenterKey + `--${entityId}`;
		const displayAttendanceObj = participantsAttendanceMap.get(dateSlotCenterEntityKey);


		const attendanceStatus: AttendanceStatus = Helper.getAttendanceStatus(displayAttendanceObj);

		if (attendanceStatus === 'PRESENT') {

			const checkInTs = displayAttendanceObj.latestCheckIn;
			const checkOutTs = displayAttendanceObj.latestCheckOut;

			if (!checkInTs && !checkOutTs) {
				return <div className={styles.presentStatus}>
					{formatMsg('present')}
				</div>
			}

			const checkInTime = checkInTs
				? timeutil.getInstance(displayAttendanceObj.latestCheckIn).format("hh:mm A")
				: formatMsg('small.pending');
			const checkOutTime = checkOutTs
				? timeutil.getInstance(displayAttendanceObj.latestCheckOut).format("hh:mm A")
				: formatMsg('small.pending');


			const checkInLabel = `${displayAttendanceObj.lateIn ? formatMsg('lateIn') : formatMsg('capital.in')} ${checkInTime}`;
			const checkOutLabel = `${displayAttendanceObj.lateOut ? formatMsg('lateOut') : formatMsg('out')} ${checkOutTime}`;

			return (
				<div className={styles.checkInCheckOutStatus}>
					<span className={displayAttendanceObj.lateIn ? styles.lateText : checkInTime === formatMsg('small.pending') ? styles.pendingText : styles.withoutLateText}>
						{checkInLabel}
					</span>
					<span className={displayAttendanceObj.lateOut ? styles.lateText : checkOutTime === formatMsg('small.pending') ? styles.pendingText : styles.withoutLateText}>
						{" - " + checkOutLabel}
					</span>
				</div>
			)
		}
		else if (attendanceStatus === 'ABSENT') {
			return <div className={styles.absentStatus}> {formatMsg('absent')} </div>;
		}
		else {
			return <div className={styles.pendingStatus}> {formatMsg('pending')} </div>;
		}
	}

	function getEntityAttendanceStatusIcon(entityId: string) {

		const dateSlotCenterEntityKey = dateSlotCenterKey + `--${entityId}`;

		const displayAttendanceObj = participantsAttendanceMap.get(dateSlotCenterEntityKey);
		const attendanceStatus: AttendanceStatus = Helper.getAttendanceStatus(displayAttendanceObj);

		if (attendanceStatus === 'PRESENT') {
			return (
				<div className={styles.attendanceStatusIcon}>
					<img
						src='/images/greenTickV2.png'
						className={styles.tickImg}
					/>
				</div>
			);
		}
		else if (attendanceStatus === 'ABSENT') {
			return (
				<div className={styles.attendanceStatusIcon}>
					<img
						src='/images/redCrossV2.png'
						className={styles.tickImg}
					/>
				</div>
			)
		}
		else {
			return (
				<div className={styles.attendanceStatusIcon}>
					<img
						src='/images/yellowExclaimation.png'
						className={styles.tickImg}
					/>
				</div>
			)
		}
	}


	const handlePackageFilterChange = useCallback((packageFilterVal) => {
		const isAllSelected: boolean = packageFilterVal?.some((val) => val === 'all packages') || false;

		if (packageList && isAllSelected) {
			packageFilterVal = packageList.filter((item) => item?.status?.toLowerCase() !== "inactive" && item?.status?.toLowerCase() !== "draft")?.map((item) => item.id);
		}

		let stringifiedData = packageFilterVal ? JSON.stringify(packageFilterVal) : '';

		setpackageFilter(packageFilterVal);
		setBatchFilter(null);
		Helper.setUrlParam("packageFilter", stringifiedData);

	}, [setpackageFilter, packageList]);


	const handleCenterFilterChange = useCallback((centerFilterVal) => {

		const isAllSelected: boolean = centerFilterVal?.some((val) => val === 'all centers') || false;

		if (multicenterReducer.allCentersList && isAllSelected) {
			centerFilterVal = multicenterReducer.allCentersList.map((item) => item.id);
		}

		let stringifiedData = centerFilterVal ? JSON.stringify(centerFilterVal) : '';

		setCenterFilter(centerFilterVal);
		Helper.setUrlParam("centerFilter", stringifiedData);
	}, [setCenterFilter, multicenterReducer.allCentersList]);


	const handleInstructorFilterChange = useCallback((instructorFilterVal) => {

		const isAllSelected: boolean = instructorFilterVal?.some((val) => val === 'allInstructors') || false;

		if (isAllSelected) {
			instructorFilterVal = Helper.getTeacherList(firebase).map((item) => item.id);
		}

		let stringifiedData = instructorFilterVal ? JSON.stringify(instructorFilterVal) : '';

		setInstructorFilter(instructorFilterVal);
		Helper.setUrlParam("instructorFilter", stringifiedData);

	}, [setInstructorFilter]);

	const handleBatchFilterChange = useCallback((batchFilterVal) => {

		const isAllSelected: boolean = batchFilterVal?.some((val) => val === 'all batches') || false;

		if (filteredBatchList && isAllSelected) {
			batchFilterVal = filteredBatchList.map((item) => item.id);
		}

		let stringifiedData = batchFilterVal ? JSON.stringify(batchFilterVal) : '';

		setBatchFilter(batchFilterVal);
		Helper.setUrlParam(`batchFilter`, stringifiedData);

	}, [setBatchFilter, filteredBatchList]);


	function getUrlParam() {

		let search = Helper.getUrlParam('calendarSearch');
		search = Helper.checkUrlParam(search, undefined);
		if (search) setSearch(search);

		let centerFilterJSONString = Helper.getUrlParam("centerFilter");
		let centerFilterParsedJSON = centerFilterJSONString ? JSON.parse(centerFilterJSONString) : undefined;
		if (centerFilterParsedJSON) setCenterFilter(centerFilterParsedJSON);

		let instructorFilterJSONString = Helper.getUrlParam("instructorFilter");
		let instructorFilterParsedJSON = instructorFilterJSONString ? JSON.parse(instructorFilterJSONString) : undefined;
		if (instructorFilterParsedJSON) setInstructorFilter(instructorFilterParsedJSON);

		if (isView(['adminPackageDetailView'])) {
			const id = Helper.getUrlParam("id");
			if (id) setpackageFilter([id]);
		} else {
			let packageFilterJSONString = Helper.getUrlParam("packageFilter");
			let packageFilterParsedJSON = packageFilterJSONString ? JSON.parse(packageFilterJSONString) : undefined;
			if (packageFilterParsedJSON) setpackageFilter(packageFilterParsedJSON);
		}

		let batchFilterJSONString = Helper.getUrlParam("batchFilter");
		let batchFilterParsedJSON = batchFilterJSONString ? JSON.parse(batchFilterJSONString) : undefined;
		if (batchFilterParsedJSON) setBatchFilter(batchFilterParsedJSON);
	}

	useEffect(() => {
		let newBatchList = (!packageFilter || packageFilter.length === 0)
			? packageReducer.batchList
			: packageReducer.batchList?.filter((obj) => packageFilter.includes(obj.packageId))
		setFilteredBatchList(newBatchList);
	}, [packageReducer.batchList, packageFilter])

	useEffect(() => {

		getUrlParam();

		if (Helper.getUrlParam("toggle"))
			setToggle(Helper.getUrlParam("toggle") ? Number(Helper.getUrlParam("toggle")) : 1)

		!Helper.isAccount(firebase) && dispatch(getAllCentersList({ firebase: firebase }));
		dispatch(getAllBatches({ firebase }));
		if (Helper.isAccount(firebase)) {
			dispatch(getPackageList({ loggedInData: firebase }));
		} else {
			dispatch(fetchPackage({ firebase: firebase }));
		}
	}, [])

	useEffect(() => {
		// For teachers, filter packages by CALENDAR_VIEW permission per package centers
		const filterPackagesByPermission = (list: any[]) => {
			if (!Helper.isTeacher(firebase)) return list;
			return list.filter(pkg => {
				const centerIds = pkg.centers?.map((center: any) => center.id) || [];
				return centerIds.length > 0 &&
					permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.CALENDAR_VIEW, centerIds)
				// pkg.status?.toLowerCase() !== "inactive" &&
				// pkg.status?.toLowerCase() !== "draft";
			});
		};

		if (packageReducer.packages.length) {
			setPackageList(filterPackagesByPermission(packageReducer.packages));
		}
		if (accountPackageReducer.packageList.length) {
			setPackageList(filterPackagesByPermission(accountPackageReducer.packageList));
		}
	}, [packageReducer.packages, accountPackageReducer.packageList, firebase])


	useEffect(() => {
		let packageMap = new Map();
		let packageColorMap = new Map();
		let index = 0;
		let calenderList = calendarReducer.calendars?.filter(item => permissions.hasAnyPermissionForEntity(firebase, [permissions.PERMISSIONS.CALENDAR_VIEW], [item.centerId]));
		calenderList?.forEach((item) => {
			if (!packageMap.has(item.packageId)) {
				packageMap.set(item.packageId, index++);
			}
		});

		calenderList?.forEach((item) => {
			if (!packageColorMap.has(item.packageId)) {
				packageColorMap.set(item.packageId, Helper.assignPackageColors(packageMap.get(item.packageId)));
			}
		});

		let listWithColors = calenderList?.map((item) => {
			return {
				...item,
				color: { darkColor: Helper.assignPackageColors(packageMap.get(item.packageId)) }
			}
		});
		setListWithColors(listWithColors);
		setPackageColorMap(packageColorMap);
	}, [calendarReducer.calendars])


	useEffect(() => {
		let newPackageMap = new Map();
		packageList?.forEach(item => {
			newPackageMap.set(item.id, item)
		})
		setPackageMap(newPackageMap);
	}, [packageList])

	useEffect(() => {
		let newCenterMap = new Map();
		multicenterReducer.allCentersList?.forEach(item => {
			newCenterMap.set(item.id, item)
		});
		setCenterMap(newCenterMap);
	}, [multicenterReducer.allCentersList]);

	useEffect(() => {
		let newTeacherMap = new Map();
		Helper.getTeacherList(firebase)?.forEach(item => {
			newTeacherMap.set(item.id, item)
		});
		setTeacherMap(newTeacherMap);
	}, [firebase.teacherList]);

	useEffect(() => {
		const newBatchesMap = new Map();
		(packageReducer.batchList || []).forEach((batchObj) => {
			newBatchesMap.set(batchObj.id, batchObj);
		});
		setBatchesMap(newBatchesMap);

	}, [packageReducer.batchList]);


	useEffect(() => {
		let filtered = listWithColors || [];

		const selectedInstructorsSet = instructorFilter?.length ? new Set(instructorFilter) : null;
		const selectedPackagesSet = packageFilter?.length ? new Set(packageFilter) : null;
		const selectedCentersSet = centerFilter?.length ? new Set(centerFilter) : null;
		const selectedBatchesSet = batchFilter?.length ? new Set(batchFilter) : null;
		const searchTerm = debouncedSearch?.toLowerCase();
		if (
			selectedInstructorsSet ||
			selectedPackagesSet ||
			selectedCentersSet ||
			selectedBatchesSet ||
			searchTerm
		) {
			filtered = filtered.filter(cal => {
				const packageObj = packageMap?.get(cal.packageId);
				if (!packageObj) return false;

				if (
					cal.instructors && selectedInstructorsSet &&
					!cal.instructors.some(staffId => selectedInstructorsSet.has(staffId))
				) return false;

				if (
					selectedPackagesSet &&
					!selectedPackagesSet.has(cal.packageId)
				) return false;

				if (
					selectedCentersSet &&
					!selectedCentersSet.has(cal.centerId)
				) return false;

				if (
					selectedBatchesSet &&
					!selectedBatchesSet.has(cal.batchId)
				) return false;

				if (searchTerm) {
					const packageName = packageObj.name?.toLowerCase() || '';
					const batchName = cal.batchName?.toLowerCase() || '';
					if (!packageName.includes(searchTerm) && !batchName.includes(searchTerm)) return false;
				}

				return true;
			});
		} else {
			Helper.setUrlParam("package", "");
		}
		setFilteredCalendars(filtered);
	}, [packageFilter, listWithColors, instructorFilter, centerFilter, debouncedSearch, packageMap, batchFilter]);


	useEffect(() => {
		const id = setTimeout(() => {
			setDebouncedSearch(search);
		}, 1000); // Adjust debounce time as needed
		return () => (clearInterval(id))
	}, [search]);

	function getEntityDetail() {
		let entityType = Helper.getUrlParam("entityType");
		let id = Helper.getUrlParam("id");
		if (Helper.isAccount(firebase)) {
			if (entityType === "booking") {
				return {
					id: firebase.user.id,
					entityType: "account"
				}
			} else {
				return {
					id: firebase.user.id,
					entityType: "account"
				}
			}
		} else {
			if (entityType === "account") {
				return {
					id: Helper.isAccount(firebase) ? firebase.user.id : id,
					entityType: entityType
				}
			} else if (entityType === "user") {
				return {
					id: id,
					entityType: entityType
				}
			}
		}
	}

	function isView(inputArr) {
		return inputArr.some((viewVal) => viewVal === props.view);
	}
	useEffect(() => {
		if (selectedSchedule) {
			dispatch(getScheduleDetail({
				firebase,
				packageId: selectedSchedule.packageId,
				date: selectedSchedule.date,
				slotRandomId: selectedSchedule.slotRandomId,
				batchId: selectedSchedule.batchId,
				entityType: getEntityDetail()?.entityType,
				entityId: getEntityDetail()?.id,
				centerId: selectedSchedule.centerId,
			}))
		}
	}, [selectedSchedule])

	useEffect(() => {
		return () => {
			dispatch(sagaSuccess({ calendars: [] }))
		}
	}, [])

	const handleSearch = (e) => {
		setSearch(e.target.value);
		Helper.setUrlParam('calendarSearch', e.target.value ? e.target.value : '');
	}

	return (
		<div>
			<div
				className='laptop-calendar-view'
			>
				<LaptopCalendarView
					search={search}
					handleSearch={handleSearch}
					packageList={packageList}
					packageFilter={packageFilter}
					handlePackageFilterChange={handlePackageFilterChange}
					instructorFilter={instructorFilter}
					handleInstructorFilterChange={handleInstructorFilterChange}
					teacherMap={teacherMap}
					allCentersList={multicenterReducer.allCentersList}
					centerFilter={centerFilter}
					handleCenterFilterChange={handleCenterFilterChange}
					centerMap={centerMap}
					toggle={toggle}
					setToggle={setToggle}
					packageMap={packageMap}
					filteredCalendars={filteredCalendars}
					selectedSchedule={selectedSchedule}
					setSelectedSchedule={setSelectedSchedule}
					mode={props.mode}
					calendarReducer={calendarReducer}
					firebase={firebase}
					getParticipantsChildren={getParticipantsChildren}
					participantAttendanceStats={participantAttendanceStats}
					filteredBatchList={filteredBatchList}
					batchesMap={batchesMap}
					batchFilter={batchFilter}
					handleBatchFilterChange={handleBatchFilterChange}
					view={props.view}
					isView={isView}
				/>
			</div>
			<div
				className='mobile-calendar-view'
			>
				<MobileCalendarView
					search={search}
					handleSearch={handleSearch}
					packageList={packageList}
					packageFilter={packageFilter}
					handlePackageFilterChange={handlePackageFilterChange}
					instructorFilter={instructorFilter}
					handleInstructorFilterChange={handleInstructorFilterChange}
					allCentersList={multicenterReducer.allCentersList}
					centerFilter={centerFilter}
					handleCenterFilterChange={handleCenterFilterChange}
					filteredCalendars={filteredCalendars}
					selectedSchedule={selectedSchedule}
					setSelectedSchedule={setSelectedSchedule}
					calendarReducer={calendarReducer}
					firebase={firebase}
					getParticipantsChildren={getParticipantsChildren}
					participantAttendanceStats={participantAttendanceStats}
					filteredBatchList={filteredBatchList}
					batchesMap={batchesMap}
					batchFilter={batchFilter}
					handleBatchFilterChange={handleBatchFilterChange}
					view={props.view}
					isView={isView}
				/>
			</div>
		</div>
	)
}

export default page